import { Alert }                  from "@/components/ui/alert";
import { Box }                    from "@chakra-ui/react";
import { Button }                 from "@/components/ui/button";
import { Center }                 from "@chakra-ui/react";
import { Image }                  from '@chakra-ui/react';
import React                      from "react";
import { Spinner }                from "@chakra-ui/react";
import UserConfirmEmailTokenModel from "@/models/services/fondations/UserConfirmEmailTokenModel";
import authStore                  from "@/stores/authStore";
import logo                       from '@/assets/images/logo-white.png';
import useFetch                   from "@widesk-core/hooks/useFetch";
import { useNavigate }            from "react-router-dom";
import { useSearchParams }        from "react-router-dom";
import { useTranslation }         from "react-i18next";
import useTranslations            from "@/hooks/useTranslations";

const ConfirmationEmailPage = () => {
	const [searchParams] = useSearchParams();
	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();
	const navigate = useNavigate();
	const [isSuccess, setIsSuccess] = React.useState<boolean>();

	useFetch(async () => {
		const token = searchParams.get('t');
		try {
			await new UserConfirmEmailTokenModel({ token }).patch();
			authStore.clear();
			setIsSuccess(true);
		} catch (error) {
			setIsSuccess(false);
			console.log(error);
		}
	}, true);

	if (isSuccess === undefined) {
		return (
			<Center height="100%" >
				<Spinner borderWidth="4px" size="xl" />
			</Center>
		);
	};

	return (
		<>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="center"
				backgroundColor="white"
				height="100px"
			>
				<Image src={logo} width="230px" />
			</Box>
			<Box
				display="flex"
				flexDirection="column"
				alignItems="center"
				justifyContent="center"
				backgroundColor="white"
				height="calc(100vh - 100px)"
				paddingBottom="150px"
			>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					gap="50px"
					maxWidth="500px"
					padding="0 50px"
				>

					<Alert 
						status={isSuccess ? 'success' : 'error'} 
						title={t(`pages.confirmationEmail.${isSuccess ? 'success' : 'error'}.title`)} 
						
					>
						{t(`pages.confirmationEmail.${isSuccess ? 'success' : 'error'}.description`)}
					</Alert>

					<Button 
						textWrap="wrap"
						height="unset"
						padding="12px 22px"
						onClick={
							() => navigate(getNavigationTranslation('login', 'path'))
						}>{
							isSuccess ? 
							t(`pages.login.form.actions.login`) 
							: t(`pages.confirmationEmail.returnToLoginPage`)
						}
					</Button>
				</Box>
			</Box>
		</>
	)
}

export default ConfirmationEmailPage;